<template>
  <div>
    <ResearchIns/>
  </div>
</template>

<script>
import ResearchIns from '@/components/research/index.vue'
export default {
  components: {
    ResearchIns
  },
}
</script>

<style>
</style>
